import styles from '../styles.module.scss';
import cn from 'classnames';
import { forwardRef, SelectHTMLAttributes } from 'react';
import { FieldError } from 'react-hook-form';
import { SelectOptions } from 'ts-types';

export interface SelectInputProps<V = string> extends SelectHTMLAttributes<HTMLSelectElement> {
  error?: FieldError;
  additionalClass?: string;
  values: SelectOptions<V, string>[];
  isSmallSize?: boolean;
  placeholder?: string;
  showEmptyOption?: boolean;
}

export const SelectInput = forwardRef<HTMLSelectElement, SelectInputProps<any>>(
  (
    {
      error,
      additionalClass = '',
      isSmallSize = false,
      values,
      placeholder = 'Select...',
      showEmptyOption = true,
      ...rest
    },
    ref
  ) => (
    <select
      ref={ref}
      className={cn('form-select form-select-solid', additionalClass, {
        [styles.invalidInput]: error?.message,
        'form-select-sm': isSmallSize
      })}
      {...rest}
    >
      {showEmptyOption && <option value="">{placeholder}</option>}
      {values.map((option) => (
        <option key={String(option.value)} value={String(option.value)}>
          {option.label}
        </option>
      ))}
    </select>
  )
);

SelectInput.displayName = 'Select';
